<div id="chartdiv" [style.width.%]="100" [style.height.%]="100"></div>
